import { Routes } from '@angular/router';
import { FileDownloadComponent } from './components/file-download/file-download.component';
import { ExpiredComponent } from './components/error-page/expired/expired.component';
import { LockComponent } from './components/error-page/lock/lock.component';
import { AccessCodeValidationComponent } from './components/file-download/access-code-validation/access-code-validation.component';
import { DownloadHelperComponent } from './components/download-helper/download-helper.component';
import { InvalidSignatureComponent } from './components/error-page/invalid-signature/invalid-signature.component';
import { InvalidUrlComponent } from './components/error-page/invalid-url/invalid-url.component';
import { VerifySignatureComponent } from './components/verify-signature/verify-signature.component';
import { ShortUrlResolveComponent } from './components/short-url-resolve/short-url-resolve.component';

export const routes: Routes = [
  { path: 'd/:shortId', component: ShortUrlResolveComponent },
  { path: 'file/verify', component: VerifySignatureComponent },
  { path: 'access-code-validation', component: AccessCodeValidationComponent },
  { path: 'download', component: FileDownloadComponent },
  { path: 'download-helper', component: DownloadHelperComponent },
  { path: 'error/invalid-signature', component: InvalidSignatureComponent },
  { path: 'error/expired', component: ExpiredComponent },
  { path: 'error/invalid-url', component: InvalidUrlComponent },
  { path: 'error/lock', component: LockComponent },
];
